import React from 'react';
import styled from "styled-components";
import {GLOBAL_STYLE_CONFIG} from "../../../app/styles/GlobalStyles";

const StyledProductPrice = styled.div`
    color: var(${GLOBAL_STYLE_CONFIG.variable('price', 'default-color')}, ${({theme}) => theme.price.defaultColor});
`

interface IProps {
    children: React.ReactNode;
    className?: string;
}

const ProductCurrentPrice: React.FC<IProps> = ({children, className = ""}) => {
    const classnames = `${GLOBAL_STYLE_CONFIG.splitByPrefix('price-current')} ${className}`
    return (
        <StyledProductPrice className={classnames}>
            {children}
        </StyledProductPrice>
    );
};

export default ProductCurrentPrice;